import { render, staticRenderFns } from "./QuestionMove.vue?vue&type=template&id=266a0f5c&scoped=true&"
import script from "./QuestionMove.vue?vue&type=script&lang=js&"
export * from "./QuestionMove.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMove.vue?vue&type=style&index=0&id=266a0f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266a0f5c",
  null
  
)

export default component.exports